import classNames from 'classnames';
import React from 'react';
import { ApplePayNameSpace } from '../../../state/applePay';
import type { ExpressCheckoutSubmitDataType } from '../../ExpressCheckout/ExpressCheckout';
import { StatsigValueType } from '../../ExpressCheckout/ExpressCheckout';
import './ApplepayNativeButton.scss';

export type ApplepayNativeButtonProps = {
    defaultLocale: string;
    handleSubmit: (props: ExpressCheckoutSubmitDataType) => void;
    ticketsCost: number;
    applePay: ApplePayNameSpace;
};

export const ApplepayNativeButton = ({
    handleSubmit,
    defaultLocale,
    ticketsCost,
    applePay,
}: ApplepayNativeButtonProps) => {
    const { canMakePaymentsWithActiveCard } = applePay;

    return (
        <button
            onClick={() =>
                handleSubmit({
                    isApplePay: true,
                    statsigValue: StatsigValueType.APPLE_PAY,
                })
            }
            className={classNames(
                'apple-pay-button-with-text apple-pay-button-black-with-text ',
                {
                    'apple-pay-button-with-setup-text':
                        canMakePaymentsWithActiveCard === false,
                    'apple-pay-button-with-pay-text':
                        ticketsCost > 0 &&
                        canMakePaymentsWithActiveCard === true,
                },
            )}
            lang={defaultLocale}
            type="button"
        >
            <span className="text"></span>
            <span className="logo"></span>
        </button>
    );
};
